<script lang="ts">
    export let name: string;
    export let role: string;
    export let imagePath: string;
</script>

<blockquote class="mt-10">
    <div class="max-w-3xl mx-auto text-center text-xl leading-9 font-medium text-gray-900">
    <slot></slot>
    </div>
    <footer class="mt-8">
    <div class="md:flex md:items-center md:justify-center">
        <div class="md:flex-shrink-0">
        <img class="mx-auto h-10 w-10 rounded-full" src="{imagePath}" alt="">
        </div>
        <div class="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
        <div class="text-base font-medium text-gray-900">{name}</div>

        <svg class="hidden md:block mx-1 h-5 w-5 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
            <path d="M11 0h3L9 20H6l5-20z" />
        </svg>

        <div class="text-base font-medium text-gray-500">{role}</div>
        </div>
    </div>
    </footer>
</blockquote>